import { createFileRoute, redirect } from "@tanstack/react-router";

/** Events now live as a tab of `/settings/sports`; the old address redirects (filters kept) so bookmarks work. */
export const Route = createFileRoute("/_app/settings/events")({
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/settings/sports", search: { ...(search as Record<string, unknown>), tab: "events" } as never, replace: true });
	},
});
